{
  "EMOJI": {
    "PLACEHOLDER": "Caută emoji-uri",
    "NOT_FOUND": "Niciun emoji nu corespunde căutării tale",
    "REMOVE": "Elimină"
  }
}
